import {
  ARH_VERSION_2_0_RELEASE_DATE,
  RECARE_FILE_TYPE,
  SCHEMA_VERSION,
} from "core/consts";
import type { AuctionForm, SchemaVersion } from "core/types";

const SCHEMA_VERSIONS: SchemaVersion[] = Object.values(SCHEMA_VERSION);

function isSchemaVersion(value: unknown): value is SchemaVersion {
  return (
    typeof value === "string" &&
    SCHEMA_VERSIONS.includes(value as SchemaVersion)
  );
}

function getStoredSchemaVersion(
  auctionForms: AuctionForm[] | null | undefined,
): SchemaVersion | undefined {
  if (!auctionForms || !Array.isArray(auctionForms)) return undefined;
  const gkvForm = auctionForms.find(
    (f) =>
      f.form_type === RECARE_FILE_TYPE.GKV_GENERAL_FORM ||
      f.form_type === RECARE_FILE_TYPE.GKV_MEDICAL_FORM,
  );
  const raw = gkvForm?.metadata?.schema_version;
  return raw && isSchemaVersion(raw) ? raw : undefined;
}

function hasAnyGKVForm(
  auctionForms: AuctionForm[] | null | undefined,
): boolean {
  return !!auctionForms?.some(
    (f) =>
      f.form_type === RECARE_FILE_TYPE.GKV_GENERAL_FORM ||
      f.form_type === RECARE_FILE_TYPE.GKV_MEDICAL_FORM,
  );
}

export function resolveArhVersion(
  auctionForms?: AuctionForm[] | null,
  referenceDate: Date = new Date(),
): SchemaVersion {
  const stored = getStoredSchemaVersion(auctionForms);

  if (isSchemaVersion(stored)) {
    return stored;
  }

  // If any form already exists but none carries a schema_version,
  // the data pre-dates the v2 introduction → treat as v1.
  if (hasAnyGKVForm(auctionForms)) {
    return SCHEMA_VERSION.V1_1_0;
  }

  return referenceDate.getTime() >= ARH_VERSION_2_0_RELEASE_DATE.getTime()
    ? SCHEMA_VERSION.V2_0_0
    : SCHEMA_VERSION.V1_1_0;
}
